import Entity from '../../utilities/entity';

class TrainingSkill extends Entity {

}

export default new TrainingSkill();